import { Button, Card, Col } from 'react-bootstrap';
import { CircleFill, InfoCircle } from 'react-bootstrap-icons';
import { useAPI } from '../services/api';
import { useModal } from '../services/modal';
import download from 'downloadjs';
import InfoModal from './InfoModal';
import '../styles/components/action-card.scss';

const ActionCard = ({
  title,
  type = '',
  active = true,
  openDate = null,
  lockDate = null,
  redirect,
  description,
}) => {
  const api = useAPI();
  const infoModal = useModal();
  const uploadModal = useModal();
  const opensLater = !active && openDate && new Date() < new Date(openDate);
  const handleUploadClick = async () => {
    uploadModal.openModal();
  };

  const handleDownloadClick = async () => {
    const { data, headers } = await fetchFileData();
    download(data, redirect, headers['content-type']);
  };

  const fetchFileData = async () => api.get(`/download/${redirect}`);

  const handleOnSubmit = async (file) => {
    let formData = new FormData();
    formData.append('file', file[0]);
    await api.post(`/${title === 'Payment File' ? 'payment' : 'snr'}`, formData);
  };

  return (
    <>
      <InfoModal
        description={description}
        handleClose={infoModal.closeModal}
        show={infoModal.show}
        title={title}
        upload={false}
      />
      <InfoModal
        description={description}
        handleClose={uploadModal.closeModal}
        show={uploadModal.show}
        title={title}
        upload={true}
        handleOnSubmit={handleOnSubmit}
      />
      <Col xs={12} md={4} className="mb-4">
        <Card
          id={title.replaceAll(' ', '-')}
          data-cy="action-card-title"
          className="h-100 dashboard-card"
        >
          <Card.Header className="action-card-header">
            <Card.Title>{title}</Card.Title>
          </Card.Header>
          <Card.Body className="d-flex flex-column justify-content-between">
            <Card.Text style={{ minHeight: '100px' }}>{description}</Card.Text>
            <Card.Text className="text-muted">
              {(lockDate || openDate) && (
                <>
                  <span className="available-date">
                    <CircleFill color={active ? 'green' : 'red'} size={12} />
                    {active && lockDate && (
                      <span>Available Until: {new Date(lockDate).toLocaleDateString()}</span>
                    )}
                    {active && !lockDate && <span>Available</span>}
                    {opensLater && (
                      <span>Locked - Opens: {new Date(openDate).toLocaleDateString()}</span>
                    )}
                    {!active && !opensLater && <span>Locked</span>}
                  </span>
                </>
              )}
            </Card.Text>
          </Card.Body>
          <Card.Footer className="d-flex align-items-baseline justify-content-between pl-2">
            <Button
              className="dark-btn"
              data-cy={type === 'Download' ? 'download-button' : 'upload-button'}
              disabled={!active}
              onClick={type === 'Download' ? handleDownloadClick : handleUploadClick}
            >
              {type}
            </Button>
            <button className="more-info" onClick={infoModal.openModal}>
              <InfoCircle className="rounded-circle" size={25} />
            </button>
          </Card.Footer>
        </Card>
      </Col>
    </>
  );
};

export default ActionCard;
